import auth0 from "auth0-js";
import history from "../../history";

export default class Auth {
  constructor() {
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.handleAuthentication = this.handleAuthentication.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
    this.getAccessToken = this.getAccessToken.bind(this);
    this.auth0 = new auth0.WebAuth({
      domain: "fikastudio.auth0.com",
      clientID: "LISduH5Z77WEjsavhOcfV1UdDCWMpYXI",
      redirectUri:
        process.env.NODE_ENV === "production"
          ? "https://networth.fika.studio/callback"
          : "http://localhost:3000/callback",
      audience: "https://fikastudio.auth0.com/userinfo",
      responseType: "token id_token",
      scope: "openid",
    });

    this.scheduleRenewal();
  }

  login() {
    this.auth0.authorize();
  }

  handleAuthentication() {
    this.auth0.parseHash((err, authResult) => {
      console.log("handleAuthentication", err, authResult);
      if (authResult && authResult.accessToken && authResult.idToken) {
        this.setSession(authResult);
        history.replace("/");
      } else if (err) {
        history.replace("/login");
        console.log(err);
      }
    });
  }

  setSession(authResult) {
    console.log("setSession", authResult);
    // Set the time that the access token will expire at
    let expiresAt = JSON.stringify(
      authResult.expiresIn * 1000 + new Date().getTime()
    );
    localStorage.setItem("access_token", authResult.accessToken);
    localStorage.setItem("id_token", authResult.idToken);
    localStorage.setItem("expires_at", expiresAt);
    // navigate to the home route
    history.replace("/");
  }

  logout() {
    // Clear access token and ID token from local storage
    localStorage.removeItem("access_token");
    localStorage.removeItem("id_token");
    localStorage.removeItem("expires_at");
    // navigate to the home route
    history.replace("/");
  }

  isAuthenticated() {
    console.log("isAuthenticated");
    // Check whether the current time is past the
    // access token's expiry time
    let expiresAt = JSON.parse(localStorage.getItem("expires_at"));
    console.log("expiresAt", expiresAt);
    return new Date().getTime() < expiresAt;
  }

  getAccessToken() {
    const accessToken = localStorage.getItem("access_token");
    if (!accessToken) {
      throw new Error("No access token found");
    }
    return accessToken;
  }

  getIdToken() {
    const idToken = localStorage.getItem("id_token");
    if (!idToken) {
      throw new Error("No id token found");
    }
    return idToken;
  }

  renewToken() {
    this.auth0.checkSession({}, (err, result) => {
      if (err) {
        console.error(
          `Could not get a new token (${err.error}: ${err.error_description}).`
        );
      } else {
        this.setSession(result);
        console.error(`Successfully renewed auth!`);
      }
    });
  }

  scheduleRenewal() {
    const expiresAt = JSON.parse(localStorage.getItem("expires_at"));
    const delay = expiresAt - Date.now();

    if (delay > 0) {
      this.tokenRenewalTimeout = setTimeout(() => {
        this.renewToken();
      }, delay);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/auth/auth.js